export function getWindowHeight() {
  // https://stackoverflow.com/questions/3437786/get-the-size-of-the-screen-current-web-page-and-browser-window
  return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
}
